import { render, staticRenderFns } from "./r-smart-offer-table.vue?vue&type=template&id=4f1f46fc"
import script from "./r-smart-offer-table.vue?vue&type=script&lang=js"
export * from "./r-smart-offer-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f1f46fc')) {
      api.createRecord('4f1f46fc', component.options)
    } else {
      api.reload('4f1f46fc', component.options)
    }
    module.hot.accept("./r-smart-offer-table.vue?vue&type=template&id=4f1f46fc", function () {
      api.rerender('4f1f46fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/r-smart-offer-table.vue"
export default component.exports